/*
 * PowerCube PDP Purchase Flow - Refined Version
 * Subtle animations, instant ATC performance, and mobile layout fixes.
 */
(function () {
  'use strict';

  const SELLING_PLANS = {
    strawberry: { 1: '692199981427', 2: '692767457651', 4: '692767490419', 6: '692767523187' },
    apple: { 1: '692199981427', 2: '692767457651', 4: '692767490419', 6: '692767523187' },
    mixed: { 2: '692473725299', 4: '692767392115', 6: '692767424883' }
  };

  const PRICING = {
    strawberry: {
      1: { onetime: 64.95, subscribe: 59.95, compare: 64.95 },
      2: { onetime: 119.90, subscribe: 109.90, compare: 129.90 },
      4: { onetime: 219.80, subscribe: 199.80, compare: 259.80 },
      6: { onetime: 299.70, subscribe: 239.70, compare: 389.70 }
    },
    apple: {
      1: { onetime: 64.95, subscribe: 59.95, compare: 64.95 },
      2: { onetime: 119.90, subscribe: 109.90, compare: 129.90 },
      4: { onetime: 219.80, subscribe: 199.80, compare: 259.80 },
      6: { onetime: 299.70, subscribe: 239.70, compare: 389.70 }
    },
    mixed: {
      2: { onetime: 119.90, subscribe: 109.90, compare: 129.90 },
      4: { onetime: 219.80, subscribe: 199.80, compare: 259.80 },
      6: { onetime: 299.70, subscribe: 239.70, compare: 389.70 }
    }
  };

  const SUPPLY_OPTIONS = {
    strawberry: [1, 2, 4, 6],
    apple: [1, 2, 4, 6],
    mixed: [2, 4, 6]
  };

  const DEFAULT_MONTHS = { strawberry: 6, apple: 6, mixed: 6 };

  const SUPPLY_COPY = {
    1: { contents: 'One Pouch - 30 servings' },
    2: { contents: 'Two Pouches - 60 servings' },
    4: { contents: 'Four Pouches - 120 servings' },
    6: { contents: 'Six Pouches - 180 servings' }
  };

  const FEATURES = {
    onetime: {
      1: [
        { icon: '✓', text: 'Try your first pouch' },
        { icon: '✓', text: 'Free Shipping Over $120' }
      ],
      2: [
        { icon: '✓', text: 'Enough to build a real routine' },
        { icon: '✓', text: 'Better value than buying monthly' },
        { icon: '✓', text: 'Free Shipping Over $120' }
      ],
      4: [
        { icon: '⚡', text: 'Free Shipping' },
        { icon: '📦', text: 'Stock up once, save more' },
        { icon: '🙌', text: 'Perfect if you already know you’ll use it' }
      ],
      6: [
        { icon: '⚡', text: 'Free Shipping' },
        { icon: '💸', text: 'Best one-time value' },
        { icon: '👍', text: 'Share with family and friends' }
      ]
    },
    subscribe: {
      1: [
        { icon: '✓', text: 'Never run out mid-routine' },
        { icon: '✓', text: 'Consistency made simple' }
      ],
      2: [
        { icon: '✓', text: 'Less reordering, same routine' },
        { icon: '✓', text: 'Better value every 2 months' },
        { icon: '✓', text: 'Keep your routine covered' }
      ],
      4: [
        { icon: '⚡', text: 'Free Shipping' },
        { icon: '💰', text: 'Strong savings every delivery' },
        { icon: '🙌', text: 'Built for people who actually stick with it' }
      ],
      6: [
        { icon: '⚡', text: 'Free Shipping' },
        { icon: '💸', text: 'Best savings' },
        { icon: '💰', text: 'Lowest cost per serve' },
        { icon: '🏆', text: 'You’re stocked, sorted, and committed' }
      ]
    }
  };

  function money(value, currency) {
    const amount = Number(value) || 0;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: currency || 'AUD',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (_error) {
      return '$' + amount.toFixed(2);
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, function (char) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char];
    });
  }

  function getType(flow) {
    const type = flow.dataset.productType;
    if (type && PRICING[type]) return type;
    if (flow.dataset.isMixed === 'true') return 'mixed';
    if (flow.dataset.isApple === 'true') return 'apple';
    return 'strawberry';
  }

  function getCartQuantity(type, months) {
    return type === 'mixed' ? Math.max(1, months / 2) : months;
  }

  function getCartAddUrl() {
    return window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url ? window.Theme.routes.cart_add_url : '/cart/add.js';
  }

  function getSavings(data, option) {
    return Math.round(Math.max(0, (Number(data.compare) || 0) - (Number(data[option]) || 0)) * 100) / 100;
  }

  function supplyFeatures(option, months) {
    return (FEATURES[option] && FEATURES[option][months]) ? FEATURES[option][months] : [];
  }

  function initFlow(flow) {
    const type = getType(flow);
    const currency = flow.dataset.currency || 'AUD';
    const variantId = flow.dataset.variantId;
    const productId = flow.dataset.productId || '';
    const variantAvailable = flow.dataset.variantAvailable !== 'false';
    const subscribeButton = flow.querySelector('[data-option="subscribe"]');
    const oneTimeButton = flow.querySelector('[data-option="onetime"]');
    const supplyContainer = flow.querySelector('[data-supply-container]');
    const addButton = flow.querySelector('[data-add-to-cart]');
    const addLabel = flow.querySelector('[data-add-to-cart-label]');
    const priceElement = flow.querySelector('[data-cart-price]');
    const messageElement = flow.querySelector('[data-pdp-message]');

    if (!subscribeButton || !oneTimeButton || !supplyContainer || !addButton || !priceElement) return;

    let currentOption = 'subscribe';
    let currentMonths = DEFAULT_MONTHS[type] || 6;
    let isAdding = false;
    let isVisuallyAdded = false;
    let addedFeedbackTimer = null;

    function currentPricing() { return PRICING[type][currentMonths]; }
    function currentTotal() {
      const price = currentPricing();
      return price ? price[currentOption] : 0;
    }

    function setMessage(text, state) {
      if (!messageElement) return;
      messageElement.textContent = text || '';
      messageElement.classList.toggle('is-error', state === 'error');
      messageElement.classList.toggle('is-success', false);
    }

    function updatePurchaseButtons() {
      subscribeButton.setAttribute('aria-pressed', currentOption === 'subscribe' ? 'true' : 'false');
      oneTimeButton.setAttribute('aria-pressed', currentOption === 'onetime' ? 'true' : 'false');
    }

    function renderSupplyCards() {
      const options = SUPPLY_OPTIONS[type] || [1, 2, 4, 6];
      if (!options.includes(currentMonths)) currentMonths = options[options.length - 1];

      supplyContainer.innerHTML = options.map(function (months) {
        const data = PRICING[type][months];
        const selected = months === currentMonths;
        const total = data[currentOption];
        const compare = data.compare || data.onetime;
        const perBag = total / months;
        const savings = getSavings(data, currentOption);
        const contents = SUPPLY_COPY[months] ? SUPPLY_COPY[months].contents : months + ' Month Supply';
        const billingLine = currentOption === 'subscribe'
          ? 'Billed ' + money(total, currency) + ' every ' + months + ' month' + (months > 1 ? 's' : '')
          : '';
        const saveBadge = savings > 0 ? '<span class="pc-pdp-supply-card__save-badge">SAVE ' + money(savings, currency).replace(/^A\$/i, '$') + '</span>' : '';
        const valueBadge = months === 6 ? '<span class="pc-pdp-supply-card__value-badge">Best Value</span>' : '';
        const features = supplyFeatures(currentOption, months).map(function (feature) {
          return '<span class="pc-pdp-supply-card__feature"><span class="pc-pdp-supply-card__feature-icon">' + escapeHtml(feature.icon) + '</span><span>' + escapeHtml(feature.text) + '</span></span>';
        }).join('');

        return '' +
          '<button type="button" class="pc-pdp-supply-card pdp-supply-card" data-months="' + months + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
            valueBadge +
            '<span class="pc-pdp-supply-card__top">' +
              '<span class="pc-pdp-supply-card__left">' +
                '<span class="pc-pdp-supply-card__headline">' +
                  '<span class="pc-pdp-supply-card__title pdp-supply-card__title">' + months + ' Month Supply</span>' + saveBadge +
                '</span>' +
                '<span class="pc-pdp-supply-card__contents">' + escapeHtml(contents) + '</span>' +
                (billingLine ? '<span class="pc-pdp-supply-card__billing">' + escapeHtml(billingLine) + '</span>' : '') +
              '</span>' +
              '<span class="pc-pdp-supply-card__right">' +
                '<span class="pc-pdp-supply-card__price-main pdp-supply-card__price-main">' + money(total, currency) + '</span>' +
                '<span class="pc-pdp-supply-card__price-row">' +
                  (compare > total ? '<span class="pc-pdp-supply-card__compare">' + money(compare, currency) + '</span>' : '') +
                  '<span class="pc-pdp-supply-card__price-sub">' + money(perBag, currency) + '/bag</span>' +
                '</span>' +
              '</span>' +
            '</span>' +
            '<span class="pc-pdp-supply-card__rule" aria-hidden="true"></span>' +
            '<span class="pc-pdp-supply-card__features">' + features + '</span>' +
            '<span class="pc-pdp-radio" aria-hidden="true"></span>' +
          '</button>';
      }).join('');
    }

    function updateCta() {
      const total = currentTotal();
      priceElement.textContent = money(total, currency);

      const missingPlan = currentOption === 'subscribe' && !SELLING_PLANS[type][currentMonths];
      const shouldDisable = !variantAvailable || !variantId || missingPlan;
      addButton.disabled = shouldDisable;
      addLabel.textContent = !variantAvailable ? 'Sold out' : missingPlan ? 'Subscription unavailable' : isVisuallyAdded ? '✓ Added' : 'Add to cart';
    }

    function setOption(option) {
      if (currentOption === option) return;
      currentOption = option;
      updatePurchaseButtons();
      renderSupplyCards();
      updateCta();
      setMessage('', '');
    }

    subscribeButton.addEventListener('click', function () { setOption('subscribe'); });
    oneTimeButton.addEventListener('click', function () { setOption('onetime'); });

    supplyContainer.addEventListener('click', function (event) {
      const button = event.target.closest('[data-months]');
      if (!button || !supplyContainer.contains(button)) return;
      if (currentMonths === Number(button.dataset.months)) return;
      
      currentMonths = Number(button.dataset.months);
      renderSupplyCards();
      updateCta();
      setMessage('', '');
    });

    async function addToCart() {
      if (isAdding) return;

      const total = currentTotal();
      const cartQty = getCartQuantity(type, currentMonths);
      const sellingPlan = SELLING_PLANS[type][currentMonths];

      if (!variantId) {
        setMessage('Unable to find the selected product variant. Please refresh and try again.', 'error');
        return;
      }

      if (currentOption === 'subscribe' && !sellingPlan) {
        setMessage('This subscription option is not configured yet. Please choose another supply option.', 'error');
        return;
      }

      isAdding = true;
      isVisuallyAdded = true;
      setMessage('', '');
      updateCta();

      if (addedFeedbackTimer) window.clearTimeout(addedFeedbackTimer);
      addedFeedbackTimer = window.setTimeout(function () {
        isVisuallyAdded = false;
        updateCta();
      }, 900);
      
      // Subtle tap feedback without leaving the button disabled/grey during the request
      addButton.style.transform = 'scale(0.98)';
      window.setTimeout(function () { addButton.style.transform = ''; }, 120);

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', String(cartQty));
      formData.append('properties[_Purchase Option]', currentOption === 'subscribe' ? 'Subscribe & Save' : 'One-Time Purchase');
      formData.append('properties[_Supply]', currentMonths + ' Month Supply');
      formData.append('properties[_Displayed PDP Total]', money(total, currency));
      formData.append('properties[_PowerCube PDP Quantity Locked]', 'true');

      const purchaseFlow = addButton.closest('.pdp-purchase-flow');
      if (purchaseFlow) {
        purchaseFlow
          .querySelectorAll('input[data-timesact-property], input[data-timesact-tracking]')
          .forEach(function (input) {
            if (input.name && !input.disabled) formData.append(input.name, input.value);
          });
      }
      
      if (currentOption === 'subscribe') formData.append('selling_plan', sellingPlan);

      // PERFORMANCE OPTIMIZATION: Do not request any sections for instant response
      // formData.append('sections', ''); 

      try {
        const response = await fetch(getCartAddUrl(), {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });

        const payload = await response.json().catch(function () { return {}; });
        if (!response.ok || payload.status) {
          throw new Error(payload.description || payload.message || 'Unable to add this selection to cart.');
        }

        isAdding = false;
        updateCta();
        addButton.style.transform = '';

        // Dispatch update event for the theme to refresh the cart
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: payload,
            sourceId: 'powercube-pdp-purchase-flow',
            data: {
              source: 'product-form-component',
              itemCount: cartQty,
              productId: productId,
              variantId: String(variantId),
              sections: {}
            }
          }
        }));
      } catch (error) {
        isAdding = false;
        isVisuallyAdded = false;
        if (addedFeedbackTimer) window.clearTimeout(addedFeedbackTimer);
        updateCta();
        addButton.style.transform = '';
        setMessage(error && error.message ? error.message : 'Unable to add this selection to cart.', 'error');
      }
    }

    addButton.addEventListener('click', addToCart);
    updatePurchaseButtons();
    renderSupplyCards();
    updateCta();
  }

  function init() {
    document.querySelectorAll('.pc-pdp-purchase-flow, .pdp-purchase-flow').forEach(function (flow) {
      if (flow.dataset.pcPdpInitialised === 'true') return;
      flow.dataset.pcPdpInitialised = 'true';
      initFlow(flow);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
